import i18n from '../i18n';

// Sunucudan Türkçe gelen oyun metinleri (efsun, stat, kaplama adları) için dil eşlemesi.
// Türkçede sunucu metni aynen kalır; diğer dillerde gameData.json'daki tablo kullanılır.
export const translateGameText = (group, key, fallback) => {
  const lang = i18n.language || 'tr';
  if (lang === 'tr') return fallback;
  const table = i18n.getResource(lang, 'gameData', group);
  return (table && key != null && table[key]) || fallback;
};

export const tInventory = (key, fallback, options = {}) =>
  i18n.t(`inventory:${key}`, { defaultValue: fallback, ...options });
